import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const COMPETITIONS_RESULT_REQUEST = 'FETCH_COMPETITIONS_RESULT_REQUEST';
export const COMPETITIONS_RESULT_FAILURE = 'FETCH_COMPETITIONS_RESULT_FAILURE';
export const COMPETITIONS_RESULT_SUCCESS = 'FETCH_COMPETITIONS_RESULT_SUCCESS';

export const fetchCompetitionResults = (competition) => {
    return function(dispatch) {
        dispatch(fetchCompetitionsRequest());
        return axios(apiRequestOptions(apiPath.COMPETITION_RESULT.LIST, {competition}))
            .then(transformHttpResponse)
            .then(response => dispatch(fetchCompetitionsSuccess(response.data, competition)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchCompetitionsFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchCompetitionsRequest = () => ({type: COMPETITIONS_RESULT_REQUEST})
const fetchCompetitionsFailure = error => ({type: COMPETITIONS_RESULT_FAILURE, error})
const fetchCompetitionsSuccess = (data, competition) => ({type: COMPETITIONS_RESULT_SUCCESS, data, competition})

/**
 * ONE CATEGORY'S ROWS, re-read for a bracket that is being watched (25 Oct
 * 2026: «тут результати не оновилися… треба, щоб не перезавантажувати
 * сторінку» — a mat confirmed a fight and the «Поєдинки» tab never knew).
 *
 * Silent — no request flag, no error snackbar: a missed poll is retried by the
 * next one. And the store is touched ONLY when a row actually changed, so a
 * quiet bracket is not re-rendered — nor its protocols re-read — every poll.
 */
export const CATEGORY_RESULTS_REFRESHED = 'CATEGORY_RESULTS_REFRESHED';

const fingerprint = rows => JSON.stringify(
    rows.map(row => [
        row.id, row.win, row.participant ? row.participant.id : null, row.place,
        row.score, row.dns, row.penaltyPoints, row.round, row.pair, row.pairType,
    ]).sort((a, b) => String(a[0]).localeCompare(String(b[0]))),
);

export const refreshCategoryResults = (competition, category) => (dispatch, getState) => (
    axios(apiRequestOptions(apiPath.COMPETITION_RESULT.LIST, { competition, category }))
        .then(transformHttpResponse)
        .then(response => {
            const fresh = (response.data || []).filter(row => row.category && row.category.id === category);
            const store = (getState().results || { data: [] }).data
                .filter(row => row.competition.id === competition && row.category.id === category);
            if (fingerprint(fresh) !== fingerprint(store)) {
                dispatch({ type: CATEGORY_RESULTS_REFRESHED, competition, category, results: fresh });
            }
        })
        .catch(() => undefined)
);

